import { dayNumberInData } from "../functions";
import type {
  CalcOptions,
  DataIndex,
  DaySettingsData,
  NumberMatrix,
} from "../algorithm.types";

type CalculateReservesParams = {
  daySettingsData: DaySettingsData;
  calcOptions: Pick<
    CalcOptions,
    | "noOfTimeSlots"
    | "noOfTechs"
    | "season"
    | "dayOfTheSeason"
    | "noOfDaysPerSeason"
  >;
  dataIndex: Pick<
    DataIndex,
    "blackout" | "shortTermStorage" | "longTermStorage"
  >;
  availData: NumberMatrix;
};

export default function calculateReserves({
  daySettingsData,
  calcOptions,
  dataIndex,
  availData,
}: CalculateReservesParams): Array<number> {
  const {
    noOfTimeSlots,
    noOfTechs,
    season,
    dayOfTheSeason,
    noOfDaysPerSeason,
  } = calcOptions;
  const reservesAvali: Array<number> = [];
  let accumulator;
  for (let j = 0; j < noOfTimeSlots; j++) {
    accumulator = 0;
    for (let i = 0; i < noOfTechs; i++) {
      if (i !== dataIndex.blackout) {
        accumulator +=
          i === dataIndex.shortTermStorage
            ? 0.3 * availData[i][j]
            : i === dataIndex.longTermStorage
            ? 0.5 * availData[i][j]
            : availData[i][j];
      }
    }

    reservesAvali.push(
      (accumulator -
        daySettingsData[
          dayNumberInData(season, dayOfTheSeason, noOfDaysPerSeason)
        ][0][j]) /
        accumulator,
    );
  }

  return reservesAvali;
}
